import { CurrencyRecord, SupportedCurrency } from '../domain/currency';
import { TransportOrder } from '../domain/transportOrder';
import { prepareFreight } from './currency';

/**
 * 
 * @param transportOrders
 * @param currencyRecord
 *
 * @return Array of tuples where each tuple contains currency code and total profit value for all transport orders in that currency
 * @example
 * // Given transport orders:
 * const orders = [
 *   { freight: { clientValue: 1000, contractorValue: 800, currency: 'EUR' }, status: 'UNLOADED' },
 *   { freight: { clientValue: 2000, contractorValue: 1500, currency: 'EUR' }, status: 'CREATED' },
 *   { freight: { clientValue: 500, contractorValue: 300, currency: 'USD' }, status: 'LOADED' }
 * ];
 * const currencies = { EUR: 1, USD: 0.85 };
 *
 * // Returns:
 * // [['EUR', 700], ['USD', 200]]
 */
export const calculateGroupedByCurrencyTotalProfit = (transportOrders: Array<TransportOrder>, currencyRecord: CurrencyRecord) =>
    Object.entries(transportOrders
        .filter(({ status }) => status !== 'DRAFT' && status !== 'STORNO')
        .reduce((acc, curr) => {
            const { clientValue, contractorValue, currency } = prepareFreight(curr.freight, currencyRecord);

            const profit = clientValue - contractorValue;
            if (isNaN(profit)) {
                return acc;
            }

            acc[currency] = acc[currency] || 0;
            acc[currency] += clientValue - contractorValue;
            return acc;
        }, {} as Record<SupportedCurrency, number>))